'use strict';

import $ from 'jquery';
import 'jquery-mask-plugin';
import Swal from 'sweetalert2';
import { scrollTo } from '../modules/scrollTo';

const lang = document.documentElement.lang;
const tr = {
  'pt-BR': {
    remove_register: 'Excluir registro?',
    remove_register_text: 'Tem certeza que deseja remover este registro?',
    remove_confirm: 'Sim, excluir registro!',
    remove_cancel: 'Não excluir',
    blocked_content: 'Você precisa realizar o seu login na plataforma para visualizar essas informações.',
    leave_challenge_question: 'Você tem certeza que quer deixar de participar desta ação?',
    leave_challenge: 'DEIXAR DE PARTICIPAR',
    participating: 'Você está participando',
    not_sure: 'Não tenho',
    sure: 'Sim, tenho',
  },
  en: {
    remove_register: 'Delete record?',
    remove_register_text: 'Are you sure you want to remove this record?',
    remove_confirm: 'Yes, delete record!',
    remove_cancel: 'Do not delete',
    blocked_content: 'You need to log in to the platform to view this information.',
    leave_challenge_question: 'Are you sure you want to stop participating in this action?',
    leave_challenge: 'STOP PARTICIPATING',
    participating: 'You are participating',
    not_sure: 'Not have',
    sure: 'Yes, have',
  },
  es: {
    remove_register: '¿Eliminar el registro?',
    remove_register_text: '¿Estás seguro de que deseas eliminar este registro?',
    remove_confirm: '¡Sí, eliminar registro!',
    remove_cancel: 'No eliminar',
    blocked_content: 'Debe iniciar sesión en la plataforma para ver esta información.',
    leave_challenge_question: '¿Estás seguro de que quieres dejar de participar en esta acción?',
    leave_challenge: 'DEJAR DE PARTICIPAR',
    participating: 'Estas participando',
    not_sure: 'No estoy',
    sure: 'Sí, estoy',
  },
};

const common = {
  settings: {
    $gtmCategory: 'eu-sou-voluntario-sb',
    $selectSuper: $('.js-superintendent'),
    $selectRegional: $('.js-regional'),
    $body: document.body,
    $toggleMenu: document.querySelector('.js-toggle-menu'),
    $btnCookies: document.querySelector('.js-btn-cookies'),
  },

  init() {
    scrollTo();

    // Função responsável pelo fechamento dos modais (c-modal)
    const $closeModal = document.querySelectorAll('.js-close-modal');

    $closeModal.length &&
      $closeModal.forEach(el => {
        el.addEventListener('click', e => {
          e.target.closest('.c-modal').classList.remove('is-active');
        });
      });

    $('.js-close-floatcard').on('click', function () {
      $(this).parent().hide();
    });

    $('.js-char-counter').on('input', function () {
      $(this).next('.o-char-counter').html($(this).val().length);
    });

    $('.c-tracks__steps-item--closed, .js-warning-closed').on('click', function (e) {
      e.preventDefault();
      Swal.fire('Para desbloquear essa etapa, você precisa concluir a etapa anterior.', '', 'warning');
    });

    $('.js-warning-maintenance').on('click', function (e) {
      e.preventDefault();
      Swal.fire(
        '<div><p>A equipe técnica está em processo de avaliação das ações realizadas pelas equipes. <br><br>Os resultados do Desafio VOAR serão divulgados em <strong>31/03</strong> e você poderá acessar a plataforma nessa data para verificar a pontuação final da sua equipe.</p><div>',
        '',
        'warning'
      );
    });

    const $msgFire = document.querySelector('[data-fire-swal]');

    if ($msgFire) {
      Swal.fire($msgFire.value, '', $msgFire.getAttribute('data-type'));
    }

    $('.js-dropup-trigger').on('click', function () {
      this.parentElement.classList.toggle('active');
    });

    $(document).on('click', function () {
      $('.c-dropup').removeClass('active');
    });

    $('.c-dropup').on('click', function (e) {
      e.stopPropagation();
    });

    s.$toggleMenu.addEventListener('click', e => {
      e.preventDefault();
      s.$body.classList.toggle('nav-active');
    });

    $('.js-form-cnpj').mask('99.999.999/9999-99');
    $('.js-form-cpf').mask('999.999.999-99');
    $('.js-form-cep').mask('99999-999');
    $('.js-form-date').mask('99/99/9999');
    $('.js-form-hour').mask('99:99');
    $('.js-form-ddd').mask('(99)');
    $('.js-form-phone').mask('(99) 99999.9999');
    $('.js-form-phone-commercial').mask('(99) 9999.9999');
    $('.js-number').mask('999999');
    $('.js-form-enrollment').mask('999999');
    $('.js-form-inep').mask('99999999');

    // Email Protective SPAM Solution
    const $mailContainer = document.querySelectorAll('[data-mail-creator]');

    if ($mailContainer.length) {
      $mailContainer.forEach(el => {
        let $mail = document.createElement('a');
        let arrMail = el.getAttribute('data-mail-creator').split(',');

        if (arrMail.length == 3) {
          let label = arrMail[0].replace(/\s/g, '') + '@' + arrMail[1].replace(/\s/g, '') + arrMail[2].replace(/\s/g, '');
          $mail.setAttribute('href', 'ma' + 'il' + 'to:' + label);
          $mail.textContent = label;
          el.appendChild($mail);
        }
      });
    }

    window.dataLayer = window.dataLayer || [];

    $('.js-gtm').on('click', function () {
      var title = $(this).attr('data-title');
      var action = $(this).attr('data-action');

      window.dataLayer.push({
        event: 'interaction',
        target: s.$gtmCategory,
        action: action,
        'target-properties': title,
      });
    });

    $('.js-gtm-input').on('blur', function () {
      if (this.value.length > 0) {
        var title = $(this).attr('data-title');
        var action = $(this).attr('data-action');

        window.dataLayer.push({
          event: 'interaction',
          target: s.$gtmCategory,
          action: action,
          'target-properties': title,
        });
      }
    });

    $(document).on('click', '.js-delete', function (e) {
      e.preventDefault();
      let data_id = $(this).attr('data-id');

      Swal.fire({
        title: tr[lang].remove_register,
        text: tr[lang].remove_register_text,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: tr[lang].remove_confirm,
        cancelButtonText: tr[lang].remove_cancel,
      }).then(result => {
        if (result.value) {
          var token = $('meta[name="csrf-token"]').attr('content');

          $.ajax({
            headers: {
              'X-CSRF-TOKEN': token,
            },
            url: $(this).attr('data-url'),
            method: 'DELETE',
            success: function (data) {
              Swal.fire(data.title, data.message, data.type);

              if (data.type == 'success') {
                var elms = document.querySelectorAll("[id='" + data_id + "']");

                for (var i = 0; i < elms.length; i++) {
                  elms[i].parentNode.removeChild(elms[i]);
                }
              }
              if (data.count) {
                $('#counter').html(data.count);
              }
            },
          });
        }
      });
    });

    //Custom delete register
    $(document).on('click', '.js-delete-custom', function (e) {
      e.preventDefault();
      let data_id = $(this).attr('data-id');
      let data_title = $(this).attr('data-message-title');
      let data_content = $(this).attr('data-message-content');

      Swal.fire({
        title: data_title,
        text: data_content,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: tr[lang].remove_confirm,
        cancelButtonText: tr[lang].remove_cancel,
      }).then(result => {
        if (result.value) {
          var token = $('meta[name="csrf-token"]').attr('content');

          $.ajax({
            headers: {
              'X-CSRF-TOKEN': token,
            },
            url: $(this).attr('data-url'),
            method: 'DELETE',
            success: function (data) {
              Swal.fire(data.title, data.message, data.type);

              if (data.type == 'success') {
                var row = document.getElementById(data_id);
                row.parentNode.removeChild(row);

                if ($('.js-counter').length && data.count) {
                  $('.js-counter').html(data.count);
                }

                if ($('.js-free-vacancies').length) {
                  var num = $('.js-free-vacancies').html();
                  $('.js-free-vacancies').html(parseInt(num) + 1);
                }
              }
            },
          });
        }
      });
    });

    const $btnParticipating = $('[data-type="participating"]'),
      $btnDisparticipate = $('[data-type="disparticipate"]'),
      $btnParticipate = $('[data-type="participate"]');

    $(document).on('click', '[data-type="participate"]', function (e) {
      e.preventDefault();
      let challengeId = $(this).attr('data-challenge'),
        isInternal = false;

      if ($('body').attr('data-controller') == 'challenges' && $('body').attr('data-action') == 'show') {
        isInternal = true;
      }

      $.ajax({
        type: 'POST',
        url: '/efetuar-inscricao/',
        data: {
          challenge_id: challengeId,
          _token: $('meta[name="csrf-token"]').attr('content'),
        },
        dataType: 'json',
        success: function (data) {
          if (data.type === 'success') {
            if (isInternal) {
              $btnParticipate.hide();
              $btnDisparticipate.show();
              $btnParticipating.show();
            } else {
              let $cards = $('.c-card[data-id="' + challengeId + '"]');
              $cards
                .find('[data-type="participate"]')
                .html(tr[lang].leave_challenge)
                .addClass('o-btn--subscribed')
                .removeClass('o-btn--primary')
                .attr('data-type', 'disparticipate');

              $cards.find('.c-card__status').addClass('active').text(tr[lang].participating);
            }
          } else {
            Swal.fire(data.title, data.message, data.type);
          }
        },
      });
    });

    $(document).on('click', '[data-type="disparticipate"]', function (e) {
      e.preventDefault();

      Swal.fire({
        title: tr[lang].leave_challenge_question,
        showCancelButton: true,
        confirmButtonColor: '#0353a7',
        cancelButtonColor: '#fff',
        cancelButtonText: tr[lang].not_sure,
        confirmButtonText: tr[lang].sure,
        padding: '50px',
        reverseButtons: true,
        customClass: 'c-new-swal',
      }).then(result => {
        if (result.value) {
          let challengeId = $(this).attr('data-challenge'),
            isInternal = false;

          if ($('body').attr('data-controller') == 'challenges' && $('body').attr('data-action') == 'show') {
            isInternal = true;
          }

          $.ajax({
            type: 'POST',
            url: '/cancelar-inscricao/',
            data: {
              challenge_id: challengeId,
              _token: $('meta[name="csrf-token"]').attr('content'),
            },
            dataType: 'json',
            success: function (data) {
              if (data.type === 'success') {
                if (isInternal) {
                  $btnParticipate.show();
                  $btnDisparticipate.hide();
                  $btnParticipating.hide();
                } else {
                  let $cards = $('.c-card[data-id="' + challengeId + '"]');
                  $cards
                    .find('[data-type="disparticipate"]')
                    .html('PARTICIPAR')
                    .removeClass('o-btn--subscribed')
                    .addClass('o-btn--primary')
                    .attr('data-type', 'participate');

                  $cards.find('.c-card__status').removeClass('active').text('Você não está participando');
                }
              } else {
                Swal.fire(data.title, data.message, data.type);
              }
            },
          });
        }
      });
    });

    $('.js-modal-warning-logged').on('click', function (e) {
      e.preventDefault();
      Swal.fire({
        html: '<h3 class="o-ttl">' + $(this).attr('data-title') + '</h3>' + '<p>' + tr[lang].blocked_content + '</p>',
        padding: '25px 15px',
        position: 'top',
        showConfirmButton: false,
        showClass: {
          popup: 'c-new-swal--popup',
        },
        customClass: 'c-new-swal',
      });
    });

    $(document).on('click', '.js-send-email', function (e) {
      e.preventDefault();
      $('#tab-send-email').removeClass('u-display--none');
    });

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('action') == 'mail') {
      $('#tab-send-email').removeClass('u-display--none');
    }

    $(document).on('click', '.js-cancel-email', function (e) {
      e.preventDefault();

      $('#tab-send-email').addClass('u-display--none');
    });

    const $customCheck = $('[data-custom-check]');

    $customCheck.on('click', function (e) {
      const $check = $(this).find('input[type="checkbox"]');

      let $status = 0;

      if ($($check).is(':checked')) {
        $check.prop('checked', false);
      } else {
        $check.prop('checked', true);
        $status = 1;
      }

      let url = $(this).attr('data-url');
      var post = {};
      post.receive_notifications = $status;
      post._token = $('meta[name="csrf-token"]').attr('content');

      $.ajax({
        type: 'POST',
        url: url,
        data: post,
        cache: false,
        dataType: 'json',
        success: function (data) {
          if (data.success) {
            Swal.fire(data.title, data.message, data.type);
          }
        },
      });
    });
  },
};

const s = common.settings;

export default common;
